// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1GeLG","row":"styles_row__2t6M2"};